import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { InventoryStockLevels } from '@domain/inventory/models/InventoryStockLevels';
import { ProductFilter } from '@domain/product/models/ProductFilter';

export function useInventoryStockLevels(filter?: ProductFilter) {
  const {
    data: stockLevels,
    isLoading,
    error,
  } = useQuery<InventoryStockLevels>({
    queryKey: ['inventoryStockLevels', filter],
    queryFn: async () => {
      const result = await container.inventoryRepository.getInventoryStockLevels(filter);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
  });

  return {
    stockLevels,
    isLoading,
    error,
  };
}
